import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import _map from "lodash/map"

import DefaultContainer from "shared/components/DefaultContainer"
import Typograph from "components/Typograph"

import styles from "../styles.css"

const ProfitCards = ({ cards }) => {
  const containerClasses = classnames(
    "Grid-cell u-size3of10",
    styles.containerCards
  )
  const itemTitleClasses = classnames(
    "u-flex u-flexAlignItemsCenter",
    styles.titleItem
  )

  const sectionClasses = classnames("u-flex", styles.containerProfits)

  return (
    <div className={sectionClasses}>
      {_map(cards, (card) => {
        return (
          <DefaultContainer customClass={containerClasses} key={card.title}>
            <div className={itemTitleClasses}>
              <img src={card.icon} alt="Benefício" />
              <Typograph
                htmlTag="h4"
                color="outer_space"
                weight="bold"
                size="medium"
                classNames={styles.titleCard}
              >
                {card.title}
              </Typograph>
            </div>
            <Typograph
              htmlTag="p"
              size="small"
              color="outer_space"
              weight="regular"
            >
              {card.desc}
            </Typograph>
            {card.inconActionComponent}
          </DefaultContainer>
        )
      })}
    </div>
  )
}

ProfitCards.propTypes = {
  cards: PropTypes.array
}

export default ProfitCards



// WEBPACK FOOTER //
// ./src/scenes/AlgarForever/components/ProfitCards.js